<template>
  <button
    v-if="showButton"
    @click="handleInstall"
    class="pwa-install-button"
  >
    Adicionar à Tela Inicial
  </button>
</template>

<script>
export default {
  data() {
    return {
      deferredPrompt: null,
      showButton: false, // Controla a exibição do botão
    };
  },
  mounted() {
    // Escuta o evento beforeinstallprompt
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();
      this.deferredPrompt = event;
      this.showButton = true;
    });
  },
  methods: {
    async handleInstall() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();

        const choiceResult = await this.deferredPrompt.userChoice;
        if (choiceResult.outcome === "accepted") {
          console.log("Usuário aceitou instalar o PWA.");
        } else {
          console.log("Usuário recusou instalar o PWA.");
        }

        this.deferredPrompt = null;
        this.showButton = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
